/**
 * @generated SignedSource<<49642df6204feef1093601327d0b867e>>
 * @relayHash a880580d17ea37c1ecf818a2e8b64373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type uiVersionDetailsQuery$variables = {
  cloudAri: string;
  cloudId: string;
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  isDevopsFeatureDisabledInFedRamp: boolean;
  isReleasesUpdateStatusPermissionFixEnabled: boolean;
  projectKey: string;
  shouldIncludeDevOpsFieldsViaAgs: boolean;
  skip: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
  versionAri: string;
};
export type uiVersionDetailsQuery$data = {
  readonly devOps: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_devOps">;
  } | null | undefined;
  readonly jira?: {
    readonly hasEditIssuesPermission?: boolean | null | undefined;
    readonly hasResolveIssuesPermission?: boolean | null | undefined;
    readonly version: {
      readonly __typename: "JiraVersion";
      readonly __typename: "JiraVersion";
      readonly name: string | null | undefined;
      readonly status: JiraVersionStatus | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"accessCheck_softwareReleasesVersionDetail" | "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type uiVersionDetailsQuery = {
  response: uiVersionDetailsQuery$data;
  variables: uiVersionDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isReleasesUpdateStatusPermissionFixEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeDevOpsFieldsViaAgs"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "status"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v15 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v16 = {
  "condition": "isReleasesUpdateStatusPermissionFixEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "hasEditIssuesPermission",
      "args": [
        (v14/*: any*/),
        {
          "kind": "Literal",
          "name": "permission",
          "value": "EDIT_ISSUES"
        },
        (v15/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "hasProjectPermission"
    },
    {
      "alias": "hasResolveIssuesPermission",
      "args": [
        (v14/*: any*/),
        {
          "kind": "Literal",
          "name": "permission",
          "value": "RESOLVE_ISSUES"
        },
        (v15/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "hasProjectPermission"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
},
v19 = {
  "kind": "Literal",
  "name": "filter",
  "value": "ALL"
},
v20 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v21 = [
  (v20/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v23 = {
  "kind": "ScalarField",
  "name": "key"
},
v24 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v25 = {
  "kind": "ScalarField",
  "name": "picture"
},
v26 = {
  "kind": "ScalarField",
  "name": "description"
},
v27 = [
  (v19/*: any*/),
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "count"
},
v29 = {
  "kind": "ScalarField",
  "name": "state"
},
v30 = {
  "concreteType": "DevOpsSummarisedBuildState",
  "kind": "LinkedField",
  "name": "buildStates",
  "plural": true,
  "selections": [
    (v29/*: any*/),
    (v28/*: any*/)
  ]
},
v31 = [
  (v28/*: any*/)
],
v32 = {
  "kind": "ScalarField",
  "name": "title"
},
v33 = [
  (v28/*: any*/),
  (v17/*: any*/)
],
v34 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v33/*: any*/)
},
v35 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v36 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v37 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v38 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiVersionDetailsQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
          }
        ]
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraQuery",
              "kind": "LinkedField",
              "name": "jira",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v10/*: any*/),
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "accessCheck_softwareReleasesVersionDetail"
                          }
                        ],
                        "type": "JiraVersion"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.version"
                },
                (v16/*: any*/)
              ]
            },
            "action": "THROW",
            "path": "jira"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiVersionDetailsQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "cloudAri"
                  },
                  {
                    "kind": "Literal",
                    "name": "providerTypes",
                    "value": [
                      "DESIGN"
                    ]
                  }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "DevOpsDesignProvider",
                    "kind": "LinkedField",
                    "name": "designProviders",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v17/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "canAddAndRemoveIssues"
                      },
                      (v18/*: any*/),
                      {
                        "alias": "allIssues",
                        "args": [
                          (v19/*: any*/)
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": "issues(filter:\"ALL\")"
                      },
                      (v22/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "startDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "releaseDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "versionId"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cloudId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "maxHierarchyLevel": 1,
                                  "minHierarchyLevel": 1
                                }
                              }
                            ],
                            "concreteType": "JiraIssueTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/)
                                        ]
                                      },
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraVersionDriverResult",
                        "kind": "LinkedField",
                        "name": "driverData",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "driver",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v24/*: any*/),
                              (v12/*: any*/),
                              (v25/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "queryError",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ]
                          }
                        ]
                      },
                      (v26/*: any*/),
                      {
                        "concreteType": "JiraVersionWarningConfig",
                        "kind": "LinkedField",
                        "name": "warningConfig",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "openReview"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                          },
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraVersionConnectAddonIframeData",
                        "kind": "LinkedField",
                        "name": "connectAddonIframeData",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "appKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "appName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "location"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "options"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canViewDevTools"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "versionIssueTableHiddenColumns"
                      },
                      {
                        "alias": "issuesForList",
                        "args": (v27/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jql"
                          },
                          {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                          "priority",
                                          "summary",
                                          "assignee",
                                          "status",
                                          "issuetype"
                                        ]
                                      }
                                    ],
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "statusCategoryId"
                                                          },
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      (v17/*: any*/),
                                                      (v12/*: any*/),
                                                      (v26/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusField"
                                              },
                                              (v17/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v11/*: any*/),
                                                      (v25/*: any*/),
                                                      (v12/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "text"
                                                  }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "xsmall"
                                                          }
                                                        ]
                                                      },
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraPriorityField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                    "kind": "LinkedField",
                                    "name": "summarisedFeatureFlags",
                                    "plural": false,
                                    "selections": (v21/*: any*/)
                                  },
                                  (v11/*: any*/),
                                  {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "DevOpsSummarisedEntities",
                                        "kind": "LinkedField",
                                        "name": "devOpsSummarisedEntities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "DevOpsSummarisedDeployments",
                                            "kind": "LinkedField",
                                            "name": "summarisedDeployments",
                                            "plural": false,
                                            "selections": [
                                              (v28/*: any*/),
                                              (v17/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "deploymentState"
                                              },
                                              {
                                                "concreteType": "DevOpsEnvironment",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironment",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "DevOpsSummarisedBuilds",
                                            "kind": "LinkedField",
                                            "name": "summarisedBuilds",
                                            "plural": false,
                                            "selections": [
                                              (v28/*: any*/),
                                              (v17/*: any*/),
                                              (v30/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueDevSummaryResult",
                                        "kind": "LinkedField",
                                        "name": "devSummaryCache",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v29/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": (v31/*: any*/)
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      (v29/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "lastUpdated"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "stateCount"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                    "kind": "LinkedField",
                                                    "name": "summaryByProvider",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "providerId"
                                                      },
                                                      (v12/*: any*/),
                                                      (v28/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": (v31/*: any*/)
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      (v28/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "failedBuildCount"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "successfulBuildCount"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "unknownBuildCount"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironments",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                        "kind": "LinkedField",
                                                        "name": "topEnvironments",
                                                        "plural": true,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          (v32/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "DevOpsSummarisedFeatureFlags",
                                        "kind": "LinkedField",
                                        "name": "summarisedFeatureFlags",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantDisplayName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantEnabled"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "mostRelevantRolloutPercentage"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          (v34/*: any*/),
                                          {
                                            "concreteType": "DevOpsSummarisedBuilds",
                                            "kind": "LinkedField",
                                            "name": "summarisedBuilds",
                                            "plural": false,
                                            "selections": [
                                              (v30/*: any*/),
                                              (v28/*: any*/),
                                              (v17/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": (v33/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v35/*: any*/)
                            ]
                          },
                          (v36/*: any*/)
                        ]
                      },
                      {
                        "alias": "issuesForList",
                        "args": (v27/*: any*/),
                        "filters": [
                          "filter",
                          "sortBy",
                          "filters"
                        ],
                        "handle": "connection",
                        "key": "ListVersion_issuesForList",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      },
                      {
                        "alias": "allIssuesRedesignTemp",
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v21/*: any*/)
                      },
                      (v18/*: any*/),
                      {
                        "args": (v37/*: any*/),
                        "concreteType": "JiraVersionApproverConnection",
                        "kind": "LinkedField",
                        "name": "approvers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraVersionApproverEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraVersionApprover",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      (v17/*: any*/),
                                      (v24/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "declineReason"
                                  },
                                  (v26/*: any*/),
                                  (v38/*: any*/),
                                  (v11/*: any*/)
                                ]
                              },
                              (v35/*: any*/)
                            ]
                          },
                          (v36/*: any*/)
                        ],
                        "storageKey": "approvers(first:100)"
                      },
                      {
                        "args": (v37/*: any*/),
                        "handle": "connection",
                        "key": "version_approvers",
                        "kind": "LinkedHandle",
                        "name": "approvers"
                      },
                      {
                        "concreteType": "JiraVersionRichTextSection",
                        "kind": "LinkedField",
                        "name": "richTextSection",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "json"
                              }
                            ]
                          },
                          (v32/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canViewVersionDetailsPage"
                      },
                      {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsSummarisedEntities",
                            "kind": "LinkedField",
                            "name": "devOpsSummarisedEntities",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsFeatureFlagProvider",
                                    "kind": "LinkedField",
                                    "name": "featureFlagProviders",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v17/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "createFeatureFlagTemplateUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "connectFeatureFlagTemplateUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "logoUrl"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v38/*: any*/)
                    ],
                    "type": "JiraVersion"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "77c627037d68e8b8fcdd635aad1ada02";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
